module.exports = __webpack_public_path__ + "img/marker_four_red3.c41f1e57.png";